import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { TypographyLocale } from 'components/TypographyLocale';
import UseAuthContext from 'context/AuthContext';
import UseLanguageContext from 'context/LanguageContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { updatePrivateArea } from 'services/private-area-services';
import { USER_ROLES } from 'utils/constants';
import { IUpdatePrivateAreaEmail, IUpdatePrivateAreaPersonal } from 'utils/contracts';
import UserEmailEdit from './UserEmailEdit';
import UserPasswordEdit from './UserPasswordEdit';
import UserPersonalInfoEdit from './UserPersonalInfoEdit';

const EditUser = () => {
  const [value, setValue] = React.useState('PERSONAL_INFO');
  const { language } = useContext(UseLanguageContext);
  const { t } = useTranslation();
  const { updateUser,role } = useContext(UseAuthContext);
  const isInspectorRole = role === USER_ROLES.INSPECTOR || role === USER_ROLES.INSPECTOR_MANAGER;
  const isManagerRole = role === USER_ROLES.MANAGER || role === USER_ROLES.ADMIN;
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };




  const updatePrivateDetails = async (data: IUpdatePrivateAreaPersonal | IUpdatePrivateAreaEmail) => {
         const result =await updatePrivateArea(data);
     if(result){
      updateUser(result);
     }
  };



  return (
    <Box sx={{  }}>
      <Box sx={{ height: "144px", alignContent: "center", mb: "22px",display:"flex", alignItems: "center" }}>
        <TypographyLocale
          language={language}
          variant='h2'
        >
          {t('USER_EDIT_HEADER')}
        </TypographyLocale>
      </Box>
      {/* <Typography variant='h4' sx={{ mb: '1rem' }}>
      </Typography> */}
      <Box sx={{ bgcolor: '#fff' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: '30px' }}>
            <TabList onChange={handleChange} aria-label='lab API tabs example'>
              <Tab label={t('USER_EDIT_PI_HEADER')} value='PERSONAL_INFO' />
              {isManagerRole && <Tab label={t('USER_EDIT_EMAIL_UPDATE_HEADER')} value='EMAIL' />}
              <Tab label={t('USER_EDIT_PASSWORD_UPDATE_HEADER')} value='PASS' />
            </TabList>
          </Box>

          <TabPanel value='PERSONAL_INFO' className='tab-content'>
            <UserPersonalInfoEdit updatePrivateDetails={updatePrivateDetails} />
          </TabPanel>
          {isManagerRole && <TabPanel value='EMAIL' className='tab-content'>
            <UserEmailEdit updatePrivateDetails={updatePrivateDetails} />
          </TabPanel>}
          <TabPanel value='PASS' className='tab-content'>
            <UserPasswordEdit />
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
};

export default EditUser;
